import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import { findEjecutivoIntendencia } from '@/api/municipalidadAPI';
import { listEjecutivoSecretariaSitioWeb } from '@/api/municipalidadAPI';
import Intendente from '../components/Ejecutivo/Intendente';
import ViceIntendente from '../components/Ejecutivo/ViceIntendente';
import Secretaria from '../components/Ejecutivo/Secretaria';
import './EjecutivoView.css';

const EjecutivoView = () => {
  const [ejecutivo, setEjecutivo] = useState(null);
  const [secretarias, setSecretarias] = useState(null);

  useEffect(() => {
    findEjecutivoIntendencia()
      .then((response) => {
        setEjecutivo(response.data);
      })
      .catch((error) => {
        console.log(error);
      });

    listEjecutivoSecretariaSitioWeb()
      .then((response) => {
        setSecretarias(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <MunicipalidadHeader tipo="Gobierno" title="Ejecutivo"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <Intendente ejecutivo={ejecutivo}></Intendente>
        <ViceIntendente ejecutivo={ejecutivo}></ViceIntendente>
        {secretarias !== null &&
          secretarias.length > 0 &&
          secretarias.map((item, idx) => <Secretaria key={idx} item={item}></Secretaria>)}
      </Container>
    </>
  );
};

export default React.memo(EjecutivoView);
